export const DEFAULT_LOGIN_ROUTE = '/api/auth/login';
export const DEFAULT_LOGOUT_ROUTE = '/api/auth/logout';
export const DEFAULT_CALLBACK_ROUTE = '/api/auth/callback';
export const DEFAULT_ACCESS_TOKEN_ROUTE = '/auth/access-token';
